import "../css/general.css";
import "../css/guide.css";
import "../css/home.css";

import { FaArrowRight } from "react-icons/fa";
import { Footer, Header, MessagePopup } from "../components";
import bookCover from "../images/one-book-cover.png";
import { IoIosArrowForward, IoIosLock, IoIosUnlock } from "react-icons/io";
import { IoArrowForwardCircle } from "react-icons/io5";
import { useEffect, useRef, useState } from "react";
import { FiSend } from "react-icons/fi";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { MdLock } from "react-icons/md";

import emailjs from "@emailjs/browser";

const Guide = () => {
    
    const [ popupMessage, setPopupMessage ] = useState("");
    const [ isPopupOpen, setPopupOpen ] = useState(false);
    const [ popupType, setPopupType ] = useState("");
    const [ popupTimer, setPopupTimer ] = useState(5000);
    const [ dialogOpen, setDialogOpen ] = useState(false);
    const [ loading, setLoading ] = useState(false);
    const phone = useRef();
    const name = useRef();
    const email = useRef();
    const role = useRef();
    const company = useRef();
    const topicRef = useRef("Marketing");

    const form = useRef();

    useEffect(() => {
        const elements = document.querySelectorAll(".fade-in-section");

        const observer = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                observer.unobserve(entry.target); // optional: stop observing after fade-in
            }
            });
        },
        { threshold: 0.1 } // 10% of the element visible triggers fade-in
        );

        elements.forEach(el => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    const SendMessage = (e) => {
        e.preventDefault();

        setLoading(true);
        
        try {
            sendEmail();
        } catch(err) {
            showMessage("Erro inesperado.", "error", 0);
            setLoading(false);
        }
        
    }

    const sendEmail = () => {
        emailjs.sendForm(
            process.env.REACT_APP_EMAILJS_SERVICE_KEY,
            process.env.REACT_APP_EMAILJS_TEMPLATE_KEY,
            form.current,
            process.env.REACT_APP_EMAILJS_PUBLIC_KEY
        )
        .then(
            (result) => {
                sendEbookEmail();
            },
            (error) => {
                console.log(error);
                showMessage("Ocorreu um erro ao adquirir guia.", "error", 0);
                setLoading(false);
            }
        );
    };
    
    const sendEbookEmail = () => {
        emailjs.sendForm(
            process.env.REACT_APP_EMAILJS_SERVICE_KEY,
            process.env.REACT_APP_EMAILJS_EBOOK_TEMPLATE_KEY,
            form.current,
            process.env.REACT_APP_EMAILJS_PUBLIC_KEY
        )
        .then(
            (result) => {
                showMessage("Guia adquirido com sucesso!", "success", 0);
                setLoading(false);
            },
            (error) => {
                console.log(error);
                showMessage("Ocorreu um erro ao adquirir guia.", "error", 0);
                setLoading(false);
            }
        );
    };

    const showMessage = (message, type, timer) => {
        setPopupMessage(message);
        setPopupType(type);
        setPopupOpen(true);
    }

    return (
        <div className="upconsult-guia">
            <Header isFromHome={false}/>
            <MessagePopup message={popupMessage} type={popupType} timer={popupTimer} confirmButtonText="OK" isOpen={isPopupOpen} closeFunc={() => setPopupOpen(false)}/>
            <section className="hero-container">
                {/* Left Column: Fixed/Sticky Image */}
                <div className="hero-left">
                    <div className="sticky-wrapper fade-in-section">
                        <img
                            src={bookCover} 
                            alt="Hero Visual" 
                            className="hero-image"
                        />
                        <div className="book-wrapper"></div>
                        <div className="book-shadow"></div>
                    </div>
                </div>

                {/* Right Column: Scrollable Content */}
                <div className="hero-right">
                    <div className="content-block">
                        <div className="content fade-in-section" style={{color: 'white'}}>
                            <h1 style={{color: 'white'}}>GUIA ESTRATÉGICO — <span className="gold">100% GRATUITO</span></h1>
                            <h2 style={{color: 'white'}}>O guia definitivo para <span className="gold">estruturar, crescer e posicionar</span> o seu negócio com <span className="gold">método, clareza</span> e <span className="gold">resultados mensuráveis</span></h2>
                            <p>Descubra como sair da estagnação, organizar a sua empresa e criar um caminho claro para crescer de forma sustentável — mesmo que hoje tudo dependa de si.</p>

                            <div>
                                <div className="check-item"><span className="check-icon">✔</span><span>Identifique os <span className="gold">verdadeiros gargalos</span></span></div>
                                <div className="check-item"><span className="check-icon">✔</span><span>Estruture a sua empresa para crescer <span className="gold">sem caos</span></span></div>
                                <div className="check-item"><span className="check-icon">✔</span><span>Saia do operacional e assuma o <span className="gold">controlo estratégico</span></span></div>
                                <div className="check-item"><span className="check-icon">✔</span><span>Implemente um plano claro para os <span className="gold">próximos 90 dias</span></span></div>
                            </div>

                            <hr className="divider" />

                            <div className="section fade-in-section">
                                <div className="section-label">Para quem é este guia</div>
                                <h2>Este guia é para si se…</h2>
                                <div className="">
                                    <div className="card-dark for-u">
                                        <p style={{fontSize:"12px", fontWeight: 700, color:"var(--gold)", letterSpacing:"1.5px", marginBottom:"20px"}}>✔ RECONHECE ALGUM DISTO?</p>
                                        <div className="check-item"><span className="check-icon">✔</span><span>Tem uma empresa, mas sente que tudo depende de si</span></div>
                                        <div className="check-item"><span className="check-icon">✔</span><span>Trabalha muito, mas os resultados não acompanham</span></div>
                                        <div className="check-item"><span className="check-icon">✔</span><span>Não tem processos claros nem estrutura definida</span></div>
                                        <div className="check-item"><span className="check-icon">✔</span><span>Quer crescer, mas não sabe por onde começar</span></div>
                                        <div className="check-item" style={{marginBottom:0}}><span className="check-icon">✔</span><span>Sente que está preso no operacional</span></div>
                                    </div>

                                    <div className="card-dark not-for-u" style={{borderColor:"#2a1515", marginTop: '20px'}}>
                                        <p style={{fontSize:"12px", fontWeight:700, color:"var(--red)", letterSpacing:"1.5px", marginBottom:"20px"}}>✗ NÃO É PARA SI SE...</p>
                                        <div className="check-item"><span className="x-icon">✗</span><span>Procura soluções rápidas sem estratégia</span></div>
                                        <div className="check-item"><span className="x-icon">✗</span><span>Não está disposto a organizar o negócio</span></div>
                                        <div className="check-item" style={{marginBottom:0}}><span className="x-icon">✗</span><span>Não quer crescer de forma estruturada</span></div>
                                    </div>

                                </div>
                            </div>

                            <hr className="divider fade-in-section" />

                            <section className="fade-in-section">
                                <div className="section">
                                    <div className="section-label">Conteúdo do ebook</div>
                                    <h2 style={{width: '100%', textAlign: 'center'}}>O que vai encontrar no guia</h2>
                                    <div className="">
                                        <div>
                                        <div className="check-item"><span className="check-icon">✔</span><span>Como fazer um diagnóstico real da sua empresa</span></div>
                                        <div className="check-item"><span className="check-icon">✔</span><span>Os 5 erros que estão a travar o crescimento</span></div>
                                        <div className="check-item"><span className="check-icon">✔</span><span>Como pensar estrategicamente (mesmo sendo PME)</span></div>
                                        <div className="check-item"><span className="check-icon">✔</span><span>O método usado pela UP Consultinvest (AEIMO)</span></div>
                                        </div>
                                        <div>
                                        <div className="check-item"><span className="check-icon">✔</span><span>Como alinhar marketing com estratégia</span></div>
                                        <div className="check-item"><span className="check-icon">✔</span><span>Plano de ação prático para 90 dias</span></div>
                                        <div className="check-item"><span className="check-icon">✔</span><span>Checklist completo para evolução do negócio</span></div>
                                        </div>
                                    </div>

                                    <div className="quote-block">
                                        <span className="gold">"</span>Você não pode melhorar o que não consegue medir.<span className="gold">"</span>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </section>

            <hr className="divider fade-in-section" />

            <div className="section fade-in-section" style={{color: 'black'}}>
                <div style={{textAlign:"center", width: '100%'}}>
                    <div className="section-label" style={{textAlign:"center"}}>A realidade</div>
                    <h2 style={{fontSize:"clamp(22px,3vw,32px)", fontWeight:700, marginBottom:"12px"}}>Se for honesto consigo…</h2>
                    <p style={{color:"var(--text-muted)", fontSize:"14px", marginBottom:"28px"}}>Provavelmente reconhece pelo menos um destes sinais.</p>
                    <div style={{textAlign:"left"}}>
                        <div className="pain-item"><span className="arrow"><IoArrowForwardCircle size={24}/></span><span>A sua empresa ainda depende demasiado de si</span></div>
                        <div className="pain-item"><span className="arrow"><IoArrowForwardCircle size={24}/></span><span>Não tem clareza financeira real</span></div>
                        <div className="pain-item"><span className="arrow"><IoArrowForwardCircle size={24}/></span><span>Falta organização interna e processos definidos</span></div>
                        <div className="pain-item"><span className="arrow"><IoArrowForwardCircle size={24}/></span><span>O crescimento é instável ou inexistente</span></div>
                        <div className="pain-item"><span className="arrow"><IoArrowForwardCircle size={24}/></span><span>Está a trabalhar muito… mas <strong style={{color:"#fff"}}>sem direção estratégica</strong></span></div>
                    </div>
                </div>
            </div>

            <section id="contact" className="contact-us guia section fade-in-section" style={{marginBottom: '40px'}}>
                <h1 className="section-title" style={{marginBottom: '28px'}}>Pronto para organizar e fazer <span className="gold">crescer o seu negócio?</span></h1>
    
                <div className="contact-container reverse">
                    <div className="company-info">
                        <img src={bookCover} className="book_cover"/>
                    </div>
                    <div className="contact-form">
                        <h1>Último passo</h1>
                        <p style={{color:"var(--text-muted)", fontSize:"14px"}}>Preencha os dados abaixo e receba agora o guia completo.</p>
                        <form ref={form} method="POST" onSubmit={SendMessage}>
                            <div className="input_columns">
                                <div className="input_container">
                                    <label htmlFor="name">Nome Completo *</label>
                                    <input onChange={(e) => name.current = e.target.value} type="text" placeholder="Seu nome completo" id="name" name="name" required/>
                                </div>
                                <div className="input_container">
                                    <label htmlFor="email">Email *</label>
                                    <input onChange={(e) => email.current = e.target.value} type="email" placeholder="seu@email.com" id="email" name="email"  required/>
                                </div>
                            </div>
                            <div className="input_columns">
                                <div className="input_container">
                                    <label htmlFor="company">Empresa *</label>
                                    <input onChange={(e) => company.current = e.target.value} type="text" placeholder="Nome da sua empresa" name="company" id="company"  required/>
                                </div>
                                <div className="input_container">
                                    <label htmlFor="role">Cargo *</label>
                                    <input onChange={(e) => role.current = e.target.value} type="text" placeholder="Gerente" name="role" id="role"  required/>
                                </div>
                                <div className="input_container">
                                    <label htmlFor="role">Telemóvel *</label>
                                    <input onChange={(e) => phone.current = e.target.value} type="text" placeholder="(+238) " name="phone" id="phone"  required/>
                                </div>
                            </div>
                            <p className="microcopy" style={{margin: '10px 0'}}><IoIosLock className="gold"/> Não enviamos spam. Apenas conteúdo estratégico de valor.</p>
                            <button style={{cursor: 'pointer'}} className="form-button" type="submit">
                                {
                                    !loading
                                    ?
                                    <>
                                        Adquirir Guia <IoIosUnlock/>
                                    </>
                                    :
                                    <>
                                        <AiOutlineLoading3Quarters className="icon loading"/>
                                    </>
                                
                                }
                            </button>
                        </form>
                    </div>
                </div>
            </section>

            <Footer/>
        </div>
    )
}

export default Guide;